<template>
  <v-row dense>
    <v-col>
      <navigation-drawer
        color="white"
        :depth="1"
        permanent
        clipped
        fixed
        class="pt-8"
        :width="250"
      >
        <v-list dense class="mb-10">
          <v-list-item dense v-for="(treatmentGroup, key) in treatmentGroups" :key="key">
            <v-list-item-content>
              <v-list-item-title>
                <v-row dense>
                  <v-col class="text-body-1 gray--text text--lighten-1 font-weight-bold">
                    <v-tooltip top max-width="450">
                      <template v-slot:activator="{ on, attrs }">
                        <span :attrs="attrs" v-on="on">
                          {{ key | truncate(24) }}
                        </span>
                      </template>

                      <span>
                        {{ key }}
                      </span>
                    </v-tooltip>
                  </v-col>

                  <v-col cols="auto">
                    <v-btn icon small @click="toggleShowTreatmentGroupKey(key, treatmentGroup)">
                      <v-icon v-if="showTreatmentGroupKey === key"
                        >eva-chevron-up-outline</v-icon
                      >
                      <v-icon v-else>eva-chevron-down-outline</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-list-item-title>

              <v-timeline dense v-show="showTreatmentGroupKey === key">
                <v-timeline-item
                  v-for="item in treatmentGroup"
                  :key="item.id"
                  :color="item.id === treatmentId ? 'primary' : 'gray lighten-1'"
                  small
                >
                  <v-row dense>
                    <v-col>
                      <v-btn text block small @click="treatmentId = item.id">
                        {{
                          $moment(item.executedAt, "YYYY-MM-DD HH:mm:ss ZZ")
                            | moment("DD MMMM Y")
                        }}
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-timeline-item>
              </v-timeline>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </navigation-drawer>

      <v-row style="padding-left: 250px">
        <v-col>
         <v-row dense align="center"> 
             <v-col cols="auto" class="text-h3 gray--text">Tratamentos</v-col>

             <v-col cols="auto" class="ps-6"> 
             <authorization
              can="print"
              v-slot:default="{ authorization }">                                                                                                        
            <v-btn small icon :disabled="false" :loading="printLoading" @click="downloadArchive" v-if="authorization || forcePrint">
              <v-icon>eva-printer-outline</v-icon>                                                                  
            </v-btn>
            </authorization>
            </v-col>
          </v-row>

          <TreatmentForm
            :treatment="treatment"
            :disabled="true"
            :key="treatmentId"
            v-if="treatment"
          />
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
  import TreatmentForm from "@/components/treatment/form.vue";

  export default {
    props: {
      patient: Object,
    },
    components: {
      TreatmentForm,
    },
    data() {
      return {
        treatmentId: null,
        showTreatmentGroupKey: false,
        printLoading: false,
      };
    },
    mounted() {
      let treatment = this.lodash.first(this.treatments);

      if (treatment) {
        this.treatmentId = treatment.id;
        this.showTreatmentGroupKey = treatment.treatmentTemplate.name;
      }
    },
    apollo: {
      treatment: {
        query: require("@/graphql/treatment/treatment.gql"),
        variables() {
          return {
            treatmentId: this.treatmentId,
          };
        },
        pollInterval: 5000,
        skip() {
          return this.lodash.isEmpty(this.treatmentId);
        },
      },
    },
    computed: {
      treatments() {
        return this.lodash.orderBy(
          this.patient.treatments,
          [
            function(o) {
              return this.$moment(o.executedAt, "YYYY-MM-DD HH:mm:ss ZZ");
            }.bind(this),
          ],
          ["desc"]
        );
      },
      treatmentGroups() {
        const unordered = this.lodash.groupBy(this.treatments, "treatmentTemplate.name");
        const ordered = {};
        Object.keys(unordered)
          .sort()
          .forEach(function(key) {
            ordered[key] = unordered[key];
          });
        return ordered;
      },
    },
    methods: {
      toggleShowTreatmentGroupKey(key, treatmentGroup) {
        if (this.showTreatmentGroupKey === key) {
          this.showTreatmentGroupKey = "";
        } else {
          this.showTreatmentGroupKey = key;
          this.treatmentId = this.lodash.first(treatmentGroup).id;
        }
      },

      async refreshList() {
        await this.$apollo.queries.treatment.refetch();
      },

      async generatePreview() {
        await this.apolloMutate({
        mutation: require("@/graphql/esign/generate_preview.gql"),

        variables: {
          esignId: this.treatment.lastEsign.id,
          dynamicForm: true,
          examAppraisal: true 
        },
      });
      },

    async downloadArchive() {
      this.printLoading = true;
      await this.generatePreview();
      await this.refreshList();
      const file_url = this.treatment.lastEsign.fileUrl;
      await window.open(`${process.env.VUE_APP_BASE_URL}${file_url}`, "_blank");

      this.printLoading = false;
    },
    },
  };
</script>

<style lang="scss" scoped></style>
